module.exports = __webpack_public_path__ + "img/status-circles-ring.9ad3b4c1.svg";